module.exports = __webpack_public_path__ + "img/image30.1f55c5d3.webp";